import { Theme } from '@mui/material/styles';

export default function CardContent(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid',
          borderColor: theme.palette.divider,
          boxShadow: 'none',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 20,
          '&:last-child': {
            paddingBottom: 20,
          },
        },
      },
    },
  };
}
